<div class="auth-wrapper">
    <div class="container-fluid ">
      <div class="row flex-row h-100">
        <div class=" col-md-12 p-0 d-md-block d-lg-block">
          <div class="bg2" style="background-image: url('assets/images/login-back.png')">
            <div class="overlay"></div>
            <div class="col-xl-6 col-lg-6 col-md-9 my-auto">
              <div class="container-login">
                <div class="wrap-login">

                  <!-- <form class="login-form">-->
                    <a class="logo-centered d-flex align-items-center justify-content-center" [routerLink]="['/']" >
                      <img src="assets/images/logo.png" class="" alt="">
                      <!-- <div class="logo-text">
                        <p>  {{'form.university-hospital' | translate}}</p>
                        <p> {{'form.saudi-electronic' | translate}}</p>
                      </div> -->
                    </a>
                    <span class="login-form-title ">
                      {{'Password.checkYourEmail' | translate}}
                    </span>

                     <!-- loginfailed message-->
                    <!-- <span class="login-form-failed " *ngIf="">
                      {{'errors.loginfailed' | translate}}
                    </span> -->

                    <div class="d-flex justify-content-between">
                        <P style="color: #120f4b;">
                            {{'Password.confirmMsg' | translate}}
                        </P>
                    </div>







                    <div class="d-flex justify-content-between">
                      <!-- <button class="login-form-btn">
                                  <i class="ik ik-log-in"></i>
                              Login
                            </button>-->
                     <a [routerLink]="['/ForgetPasswordEmail']"> <button  class="login-form-btn" >
                      <i class="ik ik-corner-down-right"></i>
                        {{'Password.reSendEmail' | translate}}
                      </button>
                    </a>

                    <a [routerLink]="['/login']">
                     <button class="login-form-btn"  type="reset"> <i class="ik ik-corner-down-left"></i>   {{'Password.cancel' | translate}}</button>
                    </a>
                    </div>

                </div>
              </div>
            </div>
          </div>


        </div>


      </div>
    </div>

  </div>
